const BACKEND = import.meta.env.VITE_API_URL || 'https://api.cloudairambo.com';

export interface ProductInfo {
  name: string;
  description: string;
  brand: string;
  rate: number;
  fromOwnDB?: boolean;  // true if found in your backend
}

export async function lookupBarcode(barcode: string): Promise<ProductInfo | null> {

  // ── 1. YOUR OWN BACKEND FIRST ──────────────────────────────────────────────
  try {
    const res = await fetch(`${BACKEND}/products/lookup?barcode=${encodeURIComponent(barcode)}`);
    const data = await res.json();
    if (data.found && data.product) {
      const p = data.product;
      return {
        name: p.name,
        brand: p.brand || '',
        description: p.description || p.name,
        rate: p.rate || 0,
        fromOwnDB: true,
      };
    }
  } catch {}

  // ── 2. OPEN FOOD FACTS (food, beverages) ───────────────────────────────────
  try {
    const res = await fetch(`https://world.openfoodfacts.org/api/v0/product/${barcode}.json`);
    const data = await res.json();
    if (data.status === 1 && data.product) {
      const p = data.product;
      return {
        name: p.product_name || p.generic_name || barcode,
        brand: p.brands || '',
        description: [p.product_name, p.brands, p.quantity].filter(Boolean).join(' — '),
        rate: 0,
        fromOwnDB: false,
      };
    }
  } catch {}

  // ── 3. UPC ITEM DB (retail, electronics) ───────────────────────────────────
  try {
    const res = await fetch(`https://api.upcitemdb.com/prod/trial/lookup?upc=${barcode}`);
    const data = await res.json();
    if (data.code === 'OK' && data.items?.length > 0) {
      const item = data.items[0];
      return {
        name: item.title || barcode,
        brand: item.brand || '',
        description: item.description || item.title || barcode,
        rate: item.offers?.[0]?.price || 0,
        fromOwnDB: false,
      };
    }
  } catch {}

  // ── 4. OPEN BEAUTY FACTS (cosmetics) ───────────────────────────────────────
  try {
    const res = await fetch(`https://world.openbeautyfacts.org/api/v0/product/${barcode}.json`);
    const data = await res.json();
    if (data.status === 1 && data.product) {
      const p = data.product;
      return {
        name: p.product_name || barcode,
        brand: p.brands || '',
        description: [p.product_name, p.brands].filter(Boolean).join(' — '),
        rate: 0,
        fromOwnDB: false,
      };
    }
  } catch {}

  // ── 5. NOT FOUND ANYWHERE ──────────────────────────────────────────────────
  return null;
}

// Save a newly scanned+looked-up product to your own backend for future use
export async function saveProductToBackend(barcode: string, info: ProductInfo): Promise<void> {
  try {
    await fetch(`${BACKEND}/products/save-scanned`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        barcode,
        name: info.name,
        description: info.description,
        brand: info.brand,
        rate: info.rate,
      }),
    });
  } catch {}
}